// import { Avatar, Typography, Menu, Dropdown, Tooltip } from 'antd'
// import React from 'react'
// import { ClockCircleFilled } from '@ant-design/icons'
// import { MdCastConnected, MdMoreVert } from 'react-icons/md'
// import { Api } from 'services'
// import moment from 'moment'
// import { SquareSubIcon } from 'components/subIcon'
// import { RiWirelessChargingLine } from 'react-icons/ri'
// import { IoMdChatbubbles, IoMdVideocam } from 'react-icons/io'
// import { connect } from 'react-redux'
// import { FaGraduationCap } from 'react-icons/fa'
// const avattar = require("../../Assets/Group 11416.svg").default
// import { fetchStudentListData, setCardData, setSelectedId } from 'actions/schedule'
// import { useHistory } from 'react-router'
// import Conference from "Assets/schedule/confrence.svg"
// import Broadcast from "Assets/schedule/Broadcast.svg"
// import Offline from "Assets/schedule/ofline.svg"
// import UserAvatar from 'components/userAvatar'
// import OtherColor from "Assets/schedule/other_color.svg"



// const { Text } = Typography
// const CompletedClassCard = ({
//     completedItem, user, handleReplay, setSelectedId, setCardData, fetchStudentListData
// }) => {
//     const CustomMenu = ({ streamId, classMode, subject, isTeacher }) => (
//         <Menu style={{ width: "200px", background: "#FFFFFF", boxShadow: "8px 8px 18px #302A5F14", borderRadius: "8px" }}>
//             {
//                 classMode == "Broadcast"
//                     ?
//                     <Menu.Item key="1" onClick={() => handleReplay(streamId, subject, completedItem)}>
//                         Replay live class
//                     </Menu.Item>
//                     :
//                     null
//             }
//         </Menu>

//     );

//     const history = useHistory();


//     const markAttendanceHandler = () => {
//         setSelectedId(completedItem?.id)
//         setCardData(completedItem)
//         fetchStudentListData()
//         history.push('/schedule-attendance')

//     }

//     const menu = (
//         <Menu style={{ width: "200px", background: "#FFFFFF", boxShadow: "8px 8px 18px #302A5F14", borderRadius: "8px" }}>
//             <Menu.Item key="1" onClick={() => markAttendanceHandler()}>

//                 Edit Attendance
//             </Menu.Item>
//         </Menu>

//     );

//     const markingTimeBool = () => {
//         let endTimeMoment = moment(completedItem?.endTime, 'hh:mm:ss');
//         let currentTimeMoment = moment();
//         let durationSeconds = moment.duration(currentTimeMoment.diff(endTimeMoment)).asSeconds();
//         console.log("endTime", completedItem?.endTime, durationSeconds);
//         if (durationSeconds < 300) {
//             return true
//         }
//         return false
//     }

//     return (
//         <div className="scheduleclass-main">
//             <div style={{ display: 'flex', flexDirection: 'row' }}>
//                 <div className="scheduleclass-img-text">
//                     <div>
//                         <SquareSubIcon icon={completedItem?.subject?.icon ? completedItem?.subject?.icon : ''} name={completedItem?.subject?.name ? completedItem?.subject?.name : ''} size={40} />
//                     </div>
//                     <div style={{ width: "200px", marginLeft: '10px', display: 'flex', flexDirection: 'column' }}>
//                         {completedItem.mode == "Zoom 40" ?
//                             <div style={{ width: '75px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E7F3FF', borderRadius: '8px', padding: '2px' }}>
//                                 <IoMdVideocam style={{ color: '#1089FF' }} />
//                                 <Text style={{ fontSize: '10px', color: '#1089FF', marginLeft: '5px' }}>Zoom 40</Text>
//                             </div>
//                             : completedItem.mode == "Broadcast" ?
//                                 <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFF4D5', borderRadius: '8px', padding: '3px 7px' }}>
//                                     <img src={Broadcast} style={{ color: '#FFA931', textAlign: 'center', height: "16px", width: "16px" }} />
//                                     <Text style={{ fontSize: '10px', color: '#FFA931', marginLeft: '5px' }}>Broadcast</Text>
//                                 </div>
//                                 :
//                                 completedItem.mode == "Conference" ?
//                                     <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F6F4FE', borderRadius: '8px', padding: '3px 7px' }}>
//                                         <img src={Conference} style={{ color: '#594099', height: "16px", width: "16px" }} />
//                                         <Text style={{ color: '#594099', marginLeft: '5px', fontSize: '10px' }}>Conference</Text>
//                                     </div>
//                                     :
//                                     completedItem.mode == 'Others' ?
//                                     <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFE5F4', borderRadius: '8px', padding: '3px 7px' }}>
//                                         <img src={OtherColor} style={{ color: '#E50087',height:"16px",width:"16px" }} />
//                                         <Text style={{ color: '#E50087', marginLeft: '5px', fontSize: '10px' }}>Other</Text>
//                                     </div>
//                                     :
//                                     <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E9FCF5', borderRadius: '8px', padding: '3px 7px' }}>
//                                         <img src={Offline} style={{ color: '#28DF99', textAlign: 'center', height: "16px", width: "16px" }} />
//                                         <Text style={{ fontSize: '10px', color: '#28DF99', marginLeft: '5px' }}>Offline</Text>
//                                     </div>

//                         }
//                         <Tooltip title={completedItem?.subject?.name ? completedItem?.subject?.name : null}>
//                             <Text style={{ fontWeight: 'bold', fontSize: '15px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{completedItem?.subject?.name}</Text>
//                         </Tooltip>
//                         <div style={{ width: '100%',  display:"flex", flexDirection:"row",alignItems:"center",  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>

//                             <Tooltip title={completedItem?.standards.length != 0 ? completedItem?.standards?.map((item, index, array) => (`${item?.std + "-" + item?.section}${index === array.length - 1 ? '' : ' | '}`)) : null}>
//                                 <FaGraduationCap style={{ color: 'purple', marginRight: '5px' }} />
//                             </Tooltip>
//                             {completedItem?.standards.length != 0 ? completedItem?.standards?.map((item, index, array) => (
//                                 <Text style={{ fontSize: '80%', fontFamily: 'roboto' }} key={index}>{item?.std + "-" + item?.section}{index === array.length - 1 ? '' : ' |'}</Text>
//                             )) : null}
//                         </div>
//                     </div>
//                     {(user.privilage.includes('SuperAdmin') || user.privilage.includes('Admin') || user.role.includes('Data Operator')) && completedItem.mode == 'Broadcast' ?
//                         <div>
//                             <Dropdown overlay={<CustomMenu streamId={completedItem.roomName} classMode={completedItem.mode} subject={completedItem.subject} isTeacher={true} />} disabled={false} placement="bottomRight" >
//                                 <MdMoreVert style={{ width: "24px", height: "24px", color: "#AEAEAE" }} />
//                             </Dropdown>
//                         </div> : null}
//                     {(user?.privilage?.includes('SuperAdmin')) && (completedItem.mode == 'Offline') ?
//                         <div>
//                             {completedItem?.attendanceMarked ?
//                                 <Dropdown overlay={menu} disabled={false} placement="bottomRight" >
//                                     <MdMoreVert style={{ width: "24px", height: "24px", color: "#AEAEAE" }} />
//                                 </Dropdown>
//                                 :
//                                 null}
//                         </div>
//                         :
//                         null
//                     }
//                 </div>
//             </div>
//             <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
//                 <div style={{display:"flex", flexDirection:"row", alignItems:"center", width: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                     <UserAvatar size="small" shape="circle" name={completedItem?.teacher?.name} img={completedItem?.teacher?.image == "default.png" ? "" : `${Api._s3_url}${completedItem?.teacher?.image}`} />
//                     <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{completedItem?.teacher?.name}</Text>
//                 </div>
//                 {(user?.privilage?.includes('SuperAdmin') && (completedItem?.mode === 'Offline')) ?
//                     <div style={{ marginLeft: '15px' }}>
//                         {completedItem?.attendanceMarked ?
//                             <div>
//                                 <ClockCircleFilled style={{ fontSize: '11px', color: '#594099' }} />
//                                 <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{`${moment(completedItem?.startTime, 'HH:mm:ss').format("hh:mm A")}-${moment(completedItem?.endTime, 'HH:mm:ss').format("hh:mm A")}`}</Text>
//                             </div>
//                             :
//                             <div onClick={markAttendanceHandler} style={{ cursor: 'pointer' }}>
//                                 <Avatar shape='circle' size='small' src={avattar} />
//                                 <Text style={{ marginLeft: '5px', color: completedItem?.attendanceMarked ? '#636363' : '#1089FF', fontSize: '9px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 'bold', cursor: 'pointer' }} >{'MARK ATTENDANCE'}</Text>
//                             </div>
//                         }
//                     </div>
//                     :
//                     (user?.privilage?.includes('AttendanceMarker')) && (completedItem?.mode === 'Offline') && (markingTimeBool()) ?
//                         <div onClick={markAttendanceHandler} style={{ cursor: 'pointer' }}>
//                             <Avatar shape='circle' size='small' src={avattar} />
//                             <Text style={{ marginLeft: '5px', color: completedItem?.attendanceMarked ? '#636363' : '#1089FF', fontSize: '9px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 'bold', cursor: 'pointer' }} >{'MARK ATTENDANCE'}</Text>
//                         </div>
//                         :
//                         <div>
//                             <ClockCircleFilled style={{ fontSize: '11px', color: '#594099' }} />
//                             <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{`${moment(completedItem?.startTime, 'HH:mm:ss').format("hh:mm A")}-${moment(completedItem?.endTime, 'HH:mm:ss').format("hh:mm A")}`}</Text>
//                         </div>

//                 }

//             </div>
//         </div>
//     )
// }
// const mapStateToProps = (state) => {
//     const {
//     } = state.schedule;
//     const { user } = state.session;
//     return {
//         user
//     };
// };

// const mapDispatchToProps = (dispatch) => ({
//     fetchStudentListData: (id) => dispatch(fetchStudentListData(id)),
//     setSelectedId: (id) => dispatch(setSelectedId(id)),
//     setCardData: (value) => dispatch(setCardData(value)),
// });

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps

// )(CompletedClassCard);


import { Typography, Menu, Dropdown, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { Api } from 'services'
import { IoMdVideocam } from "react-icons/io";
import { MdMoreVert } from "react-icons/md";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import { SquareSubIcon } from "components/subIcon";

import Conference from "Assets/schedule/confrence.svg";
import Online from "Assets/schedule/online.svg";
import Offline from "Assets/schedule/offline.svg";
import OtherColor from "Assets/schedule/other_color.svg";

import UserAvatar from "components/userAvatar";
import { fetchStudentListData, setCardData, setSelectedId } from "actions/schedule";
import ScheduleDetailsDrawer from "./ScheduleDetailsDrawer";
import { getSchedulePermissions } from "./schedulePermissions";

const { Text } = Typography;

const teacherIcon = require("../../Assets/schedule/teacher.svg").default;
const timerIcon = require("../../Assets/schedule/timer.svg").default;
const avattar = require("../../Assets/Group 11416.svg").default;

const CompletedClassCard = ({
  completedItem,
  user,
  handleReplay,
  setSelectedId,
  setCardData,
  fetchStudentListData,
  togglePageLoader,
  pageLoader,
  currentDate,
}) => {
  const history = useHistory();
  const [hovered, setHovered] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  
  useEffect(() => {
    if (
      history.location.state?.scheduleId &&
      (history.location.state?.scheduleId === completedItem?.id || history.location.state?.scheduleId === completedItem?.scheduleId || history.location.state?.scheduleId === completedItem?.occurrenceId) &&
      (history.location.state?.activeTab === 'quizzes' || history.location.state?.activeTab === 'resources')
    ) {
      setDetailsOpen(true);
    }
  }, [history.location.state, completedItem.id]);

  // Role/privilege questions all go through the matrix now (schedulePermissions.js);
  // the local normalizeList / userPrivileges / hasPrivilege trio this card used to keep
  // was a second, subtly different copy of the same logic - it folded user.access into
  // the privilege list, so an access string like "schedule-admin" answered
  // hasPrivilege("admin") true.
  const isOnlineMode = completedItem?.mode === 'Broadcast' || completedItem?.mode === 'Online';
  // Details used to open for online (Broadcast) classes only, which left an offline
  // class's card inert — but an offline class has details and an attendance sheet to
  // show just the same, and the drawer already decides which tabs apply for each mode
  // (see hideResourcesTab / hideQuizzesTab / hideAttendanceTab in
  // ScheduleDetailsDrawer.js). Restore this line to go back to online-only details:
  // const canAccessDetails = isOnlineMode && (
  // Every row of the matrix that can see the Schedule module has at least one tab
  // waiting behind this card (Attendance for Operation + AttendanceMarker,
  // Resources/Quizzes for a plain Data Operator), and clicking is the only way to reach
  // any of them, so "can view the module" is the whole gate. Which tabs appear, and
  // whether they are editable, is ScheduleDetailsDrawer's call from the same matrix.
  const permissions = getSchedulePermissions(user);
  const canAccessDetails = permissions.canViewModule;

  // Mark/Edit attendance has moved into the details drawer's Attendance tab, so the
  // card no longer carries a button of its own. Restore this to bring it back:
  // const showAttendanceActionOnCard = ['offline'].includes((completedItem?.mode || '').toLowerCase()) &&
  //   ((user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('Admin') || user?.privilage?.includes('Planner') || user?.privilage?.includes('AttendanceMarker')) ||
  //    (user?.role?.includes('Teacher') && completedItem?.teacher?.id === user?.id));
  const showAttendanceActionOnCard = false;

  const duration = moment.duration(
    moment(completedItem?.endTime, "HH:mm:ss").diff(
      moment(completedItem?.startTime, "HH:mm:ss")
    )
  );

  const markAttendanceHandler = () => {
    setSelectedId(completedItem?.id);
    setCardData(completedItem);
    fetchStudentListData(completedItem?.id);
    // TEMP DIAGNOSTIC — remove once the date-restore-on-back issue is confirmed fixed.
    console.log('[attendance-date-debug] markAttendanceHandler: currentDate prop =', currentDate, 'pathname =', `${history.location.pathname}${history.location.search}`);
    // Carry the selected date back with us so the Back button on
    // /schedule-attendance can return to it explicitly (same relay pattern
    // ScheduleDetailsDrawer.js's goToRecordingsPage uses for Play -> Back) -
    // scheduleAdmin.js otherwise has no way to tell this apart from a fresh
    // visit and resets the filter to today.
    history.push("/schedule-attendance", {
      from: {
        path: `${history.location.pathname}${history.location.search}`,
        state: {
          fromRecordingPlay: true,
          currentDate,
        },
      },
    });
  };

  return (
    <>
    <div
      className="scheduleclass-main scheduleclass-main--completed"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "relative",
        padding: 16,
        borderRadius: 16,
        width: '100%',
        maxWidth: 330,
        background: "transparent",
        cursor: canAccessDetails ? "pointer" : "default",
        // border: "1px solid #AEAEAE",
      }}
      onClick={() => {
        if (canAccessDetails) {
          setDetailsOpen(true);
        }
      }}
    >
      {/* TOP BAR */}
      <div
        style={{
          // Was position:absolute with hand-picked left/right values that had to
          // coincidentally match the card's own padding for this row to line up
          // with the subject icon below it - never quite exact. A normal in-flow
          // row shares that same padding automatically, guaranteeing the two
          // rows start at the same left edge instead of approximating it.
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text style={{ fontSize: 12, color: "#636363" }}>
          {moment(completedItem?.startTime, "HH:mm:ss").format("hh:mm A")} -{" "}
          {moment(completedItem?.endTime, "HH:mm:ss").format("hh:mm A")}
        </Text>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {completedItem.mode === "Zoom 40" ? (
            <div style={{ display: "flex", alignItems: "center", backgroundColor: "#E7F3FF", borderRadius: 16, padding: "4px 10px" }}>
              <IoMdVideocam style={{ color: "#1089FF" }} />
              <Text style={{ fontSize: 10, color: "#1089FF", marginLeft: 5 }}>
                Zoom 40
              </Text>
            </div>
          ) : completedItem.mode === "Broadcast" ? (
            <div style={{ display: "flex", alignItems: "center", backgroundColor: "#E9FFF9", border: "1px solid #C8EEE4", borderRadius: 16, padding: "4px 10px" }}>
              <img src={Online} style={{ width: 14, height: 14 }} />
              <Text style={{ fontSize: 10, color: "#00A566", marginLeft: 5 }}>
                Online
              </Text>
            </div>
          ) : completedItem.mode === "Conference" ? (
            <div style={{ display: "flex", alignItems: "center", backgroundColor: "#F6F4FE", borderRadius: 16, padding: "4px 10px" }}>
              <img src={Conference} style={{ width: 14, height: 14 }} />
              <Text style={{ fontSize: 10, color: "#594099", marginLeft: 5 }}>
                Conference
              </Text>
            </div>
          ) : (completedItem.mode === "Others" || completedItem.mode === "Other") ? (
            <div style={{ display: "flex", alignItems: "center", backgroundColor: "#FFE5F4", borderRadius: 16, padding: "4px 10px" }}>
              <img src={OtherColor} style={{ width: 14, height: 14 }} />
              <Text style={{ fontSize: 10, color: "#E50087", marginLeft: 5 }}>
                Others
              </Text>
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", backgroundColor: "#FFD8DA", border: "1px solid #FFF5F6", borderRadius: 16, padding: "4px 10px" }}>
              <img src={Offline} style={{ width: 14, height: 14 }} />
              <Text style={{ fontSize: 10, color: "#FF414D", marginLeft: 5 }}>
                Offline
              </Text>
            </div>
          )}
        </div>
      </div>

      {/* MAIN CONTENT */}
      {/* paddingTop: 32 used to reserve room for the position:absolute TOP BAR -
          it's a normal in-flow row now, so it already takes its own space; this
          just needs a visual gap between the two rows. */}
      <div style={{ paddingTop: 12 }}>
        <div style={{ display: "flex", gap: 16 }}>
          <SquareSubIcon
            icon={completedItem?.subject?.icon || ""}
            name={completedItem?.subject?.name || ""}
            size={44}
          />

          <div style={{ flex: 1, minWidth: 0 }}>
            <Text 
              style={{ fontSize: 16, fontWeight: 600, color: "#1F1F1F", marginBottom: 6, display: 'block' }}
              ellipsis={{ tooltip: completedItem?.subject?.name }}
            >
              {completedItem?.subject?.name}
            </Text>

            <div style={{ display: "flex", alignItems: "center", gap: 16, fontSize: 13, color: "#636363" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                <img src={teacherIcon} style={{ width: 14 }} />
                <Text
                  ellipsis={{ tooltip: completedItem?.teacher?.name }}
                  style={{ fontSize: 13, color: "#636363", maxWidth: 120, margin: 0 }}
                >
                  {completedItem?.teacher?.name}
                </Text>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <img src={timerIcon} style={{ width: 14 }} />
                <span>{Math.round(duration.asMinutes())} mins</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BATCH NAME and ATTENDANCE ACTION in one line */}
      <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', width: '100%' }}>
        <div style={{ fontSize: 12, color: "#636363", flex: 1, minWidth: 0, overflow: 'hidden', marginRight: 16 }}>
          {completedItem?.standards && completedItem.standards.length > 0 ? (
            <Tooltip
              title={completedItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
              placement="bottom"
              getPopupContainer={(trigger) => trigger.parentElement}
            >
              <Text style={{ fontSize: 12, color: "#636363", display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                {completedItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
              </Text>
            </Tooltip>
          ) : (
            <Tooltip
              title={completedItem?.batchName || ""}
              placement="bottom"
              getPopupContainer={(trigger) => trigger.parentElement}
            >
              <Text style={{ fontSize: 12, color: "#636363", display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                {completedItem?.batchName || ""}
              </Text>
            </Tooltip>
          )}
        </div>

        <div style={{ marginLeft: 'auto' }}>
            {showAttendanceActionOnCard ? (
              <div
                onClick={(e) => { e.stopPropagation(); markAttendanceHandler(); }}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6
                }}
              >
                <img src={avattar} alt="att" style={{ width: 20, height: 20 }} />
                <span style={{ fontWeight: 600, color: "#594099", fontSize: 14, whiteSpace: 'nowrap' }}>
                  {completedItem?.attendanceMarked ? 'EDIT ATTENDANCE' : 'MARK ATTENDANCE'}
                </span>
              </div>
          ) : null}
        </div>
      </div>
    </div>

      {/* SCHEDULE DETAILS DRAWER */}
      <ScheduleDetailsDrawer
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        schedule={completedItem}
        togglePageLoader={togglePageLoader}
        pageLoader={pageLoader}
        isCompletedClass={true}
        handleReplay={handleReplay}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.session.user,
  currentDate: state.schedule?.currentDate,
});

const mapDispatchToProps = (dispatch) => ({
  fetchStudentListData: (id) => dispatch(fetchStudentListData(id)),
  setSelectedId: (id) => dispatch(setSelectedId(id)),
  setCardData: (value) => dispatch(setCardData(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompletedClassCard);
